export default Object.freeze({
    CONSULTA: 10,
    RECLAMACION: 20,
    ACLARACION: 30
})
